/* matcha-kaffee koffein-rechner — vanilla js, keine externen abhängigkeiten */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.krInit === '1') return;
    root.dataset.krInit = '1';

    var d = root.dataset;
    var cfg = {
      matchaPerG: parseFloat(d.matchaPerG) || 23,
      coffee: {
        espresso_single: parseFloat(d.espressoSingle) || 70,
        espresso_double: parseFloat(d.espressoDouble) || 140,
        filter_kaffee: parseFloat(d.filterKaffee) || 105,
        cappuccino: parseFloat(d.cappuccino) || 75,
        latte_macchiato: parseFloat(d.latteMacchiato) || 75,
      },
      efsaAdultTotal: parseFloat(d.efsaAdultTotal) || 400,
      efsaPerKg: parseFloat(d.efsaPerKg) || 5.7,
      efsaPregnancy: parseFloat(d.efsaPregnancy) || 200,
      scaleMax: 400,
    };

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var matchaCups = $('#kr-matcha-cups');
    var matchaCupsOut = $('#kr-matcha-cups-out');
    var matchaDose = $$('input[name="kr-matcha-dose"]');
    var matchaTotal = $('#kr-matcha-total');

    var coffeeCups = $('#kr-coffee-cups');
    var coffeeCupsOut = $('#kr-coffee-cups-out');
    var coffeeType = $$('input[name="kr-coffee-type"]');
    var coffeeTotal = $('#kr-coffee-total');

    var barMatcha = $('#kr-bar-matcha');
    var barMatchaFill = $('#kr-bar-matcha-fill');
    var barCoffee = $('#kr-bar-coffee');
    var barCoffeeFill = $('#kr-bar-coffee-fill');
    var barTotal = $('#kr-bar-total');
    var barTotalFill = $('#kr-bar-total-fill');

    var weight = $('#kr-weight');
    var weightOut = $('#kr-weight-out');
    var profile = $$('input[name="kr-profile"]');
    var efsaPersonal = $('#kr-efsa-personal');
    var efsaCurrent = $('#kr-efsa-current');
    var efsaProgressFill = $('#kr-efsa-progress-fill');
    var efsaProgressText = $('#kr-efsa-progress-text');

    var curveMatcha = $('#kr-curve-matcha');
    var curveCoffee = $('#kr-curve-coffee');
    var curveMatchaFill = $('#kr-curve-matcha-fill');
    var curveCoffeeFill = $('#kr-curve-coffee-fill');

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* helpers ---------------------------------------------------- */
    function checkedRadio(group, fallback) {
      for (var i = 0; i < group.length; i++) if (group[i].checked) return group[i];
      return fallback ? group[0] : null;
    }

    function fmtMg(v) { return Math.round(v).toString(); }

    /* animate number ---------------------------------------------- */
    function animateNumber(el, to) {
      if (!el) return;
      to = Math.round(to);
      var from = parseFloat(el.textContent) || 0;
      from = Math.round(from);
      if (from === to) { el.textContent = fmtMg(to); return; }
      if (prefersReducedMotion) { el.textContent = fmtMg(to); return; }
      var dur = 320;
      var start = performance.now();
      cancelAnimationFrame(el.__rafId);
      function step(now) {
        var t = Math.min(1, (now - start) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = from + (to - from) * eased;
        el.textContent = fmtMg(v);
        if (t < 1) el.__rafId = requestAnimationFrame(step);
      }
      el.__rafId = requestAnimationFrame(step);
    }

    /* compute ----------------------------------------------------- */
    function compute() {
      var mc = parseInt(matchaCups.value, 10) || 0;
      var doseEl = checkedRadio(matchaDose);
      var dose = doseEl ? parseFloat(doseEl.value) : 1.5;
      var matchaMg = mc * dose * cfg.matchaPerG;

      var cc = parseInt(coffeeCups.value, 10) || 0;
      var typeEl = checkedRadio(coffeeType);
      var type = typeEl ? typeEl.value : 'espresso_single';
      var coffeePerCup = cfg.coffee[type] || cfg.coffee.espresso_single;
      var coffeeMg = cc * coffeePerCup;

      var totalMg = matchaMg + coffeeMg;

      matchaCupsOut.textContent = mc;
      coffeeCupsOut.textContent = cc;

      animateNumber(matchaTotal, matchaMg);
      animateNumber(coffeeTotal, coffeeMg);
      animateNumber(barMatcha, matchaMg);
      animateNumber(barCoffee, coffeeMg);
      animateNumber(barTotal, totalMg);

      var max = Math.max(cfg.scaleMax, totalMg, 1);
      barMatchaFill.style.width = pct(matchaMg, max);
      barCoffeeFill.style.width = pct(coffeeMg, max);
      barTotalFill.style.width = pct(totalMg, max);

      var w = parseInt(weight.value, 10) || 70;
      var profEl = checkedRadio(profile, true);
      var profileVal = profEl ? profEl.value : 'adult';
      weightOut.innerHTML = w + '&nbsp;kg';

      var personal;
      if (profileVal === 'pregnancy') {
        personal = cfg.efsaPregnancy;
      } else {
        personal = Math.min(cfg.efsaAdultTotal, Math.round(w * cfg.efsaPerKg));
      }
      animateNumber(efsaPersonal, personal);
      animateNumber(efsaCurrent, totalMg);

      var ratio = personal > 0 ? Math.min(1.2, totalMg / personal) : 0;
      var displayRatio = Math.min(1, ratio);
      efsaProgressFill.style.width = (displayRatio * 100).toFixed(1) + '%';
      var pctVal = Math.round(ratio * 100);
      var label = pctVal + '\u00a0% des Richtwerts';
      if (ratio >= 1) label = pctVal + '\u00a0% — Tagesgrenze erreicht oder überschritten';
      else if (ratio >= 0.75) label = pctVal + '\u00a0% — nahe am Richtwert';
      efsaProgressText.textContent = label;

      drawCurve(matchaMg, coffeeMg);
    }

    function pct(v, max) { return (Math.max(0, Math.min(100, (v / max) * 100))).toFixed(1) + '%'; }

    /* svg curve --------------------------------------------------- */
    /* zwei kurven: kaffee — schneller anstieg, peak ~ 0.75 h, abbau halbwertszeit ~5 h
                  matcha — langsamer anstieg, peak ~ 1.5 h, ähnliche halbwertszeit
       y = c0 * (1 - exp(-k_a * t)) * exp(-k_e * t) — bateman-modell, vereinfacht
       y-achse: 0..yMax (yMax = 75 mg fest, skala paßt sich nicht an, damit kurven vergleichbar bleiben) */
    var SVG = { x0: 60, x1: 700, y0: 270, y1: 40, yMax: 75 };

    function bateman(c0, ka, ke, t) {
      return c0 * ka / (ka - ke) * (Math.exp(-ke * t) - Math.exp(-ka * t));
    }

    function buildPath(mgDose, ka, ke) {
      if (!mgDose) {
        return { path: 'M' + SVG.x0 + ',' + SVG.y0, fill: 'M' + SVG.x0 + ',' + SVG.y0 + ' L' + SVG.x0 + ',' + SVG.y0 + ' Z' };
      }
      var c0 = mgDose;
      var pts = [];
      var n = 90;
      for (var i = 0; i <= n; i++) {
        var t = (i / n) * 6;
        var y = bateman(c0, ka, ke, t);
        if (!isFinite(y) || y < 0) y = 0;
        var px = SVG.x0 + (i / n) * (SVG.x1 - SVG.x0);
        var py = SVG.y0 - Math.min(SVG.yMax, y) / SVG.yMax * (SVG.y0 - SVG.y1);
        pts.push([px, py]);
      }
      var d = 'M' + pts[0][0].toFixed(1) + ',' + pts[0][1].toFixed(1);
      for (var j = 1; j < pts.length; j++) d += ' L' + pts[j][0].toFixed(1) + ',' + pts[j][1].toFixed(1);
      var fillD = d + ' L' + pts[pts.length - 1][0].toFixed(1) + ',' + SVG.y0 + ' L' + SVG.x0 + ',' + SVG.y0 + ' Z';
      return { path: d, fill: fillD };
    }

    function drawCurve(matchaMg, coffeeMg) {
      var c = buildPath(coffeeMg, 3.0, 0.139);
      var m = buildPath(matchaMg, 0.95, 0.139);

      curveCoffee.setAttribute('d', c.path);
      curveCoffeeFill.setAttribute('d', c.fill);
      curveMatcha.setAttribute('d', m.path);
      curveMatchaFill.setAttribute('d', m.fill);
    }

    /* listeners --------------------------------------------------- */
    var inputs = [matchaCups, coffeeCups, weight].concat(matchaDose, coffeeType, profile);
    inputs.forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', compute);
      el.addEventListener('change', compute);
    });

    compute();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-koffein-rechner]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
